import { useEffect, useState, useMemo, useCallback } from "react";
import { PreferenceSchema, ResourceType, SearchFilterOptionType} from "../../data/types";
import { useNavigate, useParams } from "react-router-dom";
// import FilterBox from '../../components/FilterBox'
import TransactionsList, { TransactionSortField } from '../../molecules/TransactionsList'
import { SortDirection } from '../../components/SortableHeader'


import NewSearch from "../../molecules/NewSearch";
// import MembersList from '../../components/MembersList'
// import ResourceRequestList from '../../components/ResourceRequestList'
// import { ResourceType } from "../../data/types";
import {
  capitalizeString,
  filterTransactions,
  getDefaultTransactionSortDirection,
  sortTransactions,
} from "../../utils/helpers";
import { getOfferedResourcePageOptions } from "../../utils/helpers/dashboardStats";
import { ReactComponent as ResourcesIcon } from "../../icons/ResourcesIcon.svg";

import { useLoadCommunityTransactions } from "../../hooks/memberhooks";
import { useLoadCommunity } from "../../hooks/authhooks";
import { useAuthState } from "../../contexts/authcontext";
// import StripeConnect from "../../components/StripeConnect";
import DashboardAccess from '../../components/stripe/DashboardAccess';  
import AccountOnboarding from '../../components/stripe/AccountOnboarding';
import PaymentProcessing, { PaymentStatus } from "../../components/stripe/PaymentProcessing";
import PaymentAccountDetails from "../../components/stripe/PaymentAccountDetails";
import ReportingChart from "../../components/stripe/ReportingChart";
import Payouts from "../../components/stripe/Payouts";
import FinancialAccount from "../../components/stripe/FinancialAccount";
// import { menuOptionTypes } from "./Transactions";
// import { AddResourceModal } from "../../molecules/AppModal";


export type menuOptionTypes = "overview" | "bank_details" | "transactions" | "payment_account" | "payouts" | "reporting" | "payments"

type RouteParams = {
  resourceType: ResourceType
};


type TransactionsPageProps = {
  searchFilterOptions: SearchFilterOptionType
}

const TransactionsPage: React.FC<TransactionsPageProps> = ({searchFilterOptions}) => {

  const navigate = useNavigate();
  var { resourceType } = useParams<RouteParams>();
  resourceType = resourceType ? resourceType : "kitchen"

  var { authUser } = useAuthState()
  var communityId = (authUser && authUser.primary_community) ? authUser.primary_community : ""
  var { primaryCommunity } = useLoadCommunity(communityId)
  const communityPreferences = primaryCommunity?.preferences
  const resourceSelected = communityPreferences as PreferenceSchema 
  const resourceOptions = useMemo(
    () => getOfferedResourcePageOptions(resourceSelected),
    [resourceSelected]
  )
  const currentOption = resourceOptions.find((opt) => opt.type === resourceType) || resourceOptions[0]

  
  const menuOptions: {id: menuOptionTypes, name: string}[] = [
    {id: "overview", name: "Overview"}, 
    {id: "payment_account", name: `Payment Account`} ,
    {id: "bank_details", name: `Account Details`} ,
    {id: "transactions", name: `Transactions`},
    {id: "payments", name: `Payments`},
    {id: "payouts", name: `Payouts`},
    {id: "reporting", name: `Reporting`}
  ]

  const [currentMenuOption, setCurrentMenuOption] = useState<menuOptionTypes>(menuOptions[0].id)

  // console.log("currentOption", currentOption)


  useEffect(() => {
    document.title = "HomeCook | Transactions";
  }, []);

  useEffect(() => {
    if (resourceOptions.length === 0) {
      return
    }
    if (!resourceOptions.some((option) => option.type === resourceType)) {
      navigate(`/payments/${resourceOptions[0].type}`, { replace: true })
    }
  }, [navigate, resourceOptions, resourceType]);

  const activeResourceType = currentOption?.type || resourceType

  return  (
    <div className="page-canvas flex min-h-screen flex-col items-center">
      {resourceOptions.length === 0 ? (
        <div className="flex flex-col w-11/12 mx-auto my-8 rounded-2xl border border-[#E9E9E9] bg-white">
          <div className="flex flex-col items-center justify-center px-6 py-16">
            <div className="flex h-[80px] w-[80px] items-center justify-center rounded-full bg-[#EFF8FA]">
              <ResourcesIcon className="h-[40px] w-[40px] text-primary-400" />
            </div>
            <p className="mt-4 text-center font-raleway text-[20px] font-bold text-primary-200">
              Choose resources to offer
            </p>
            <p className="mt-2 max-w-md text-center font-open-sans text-[16px] text-[#333333]">
              Select the resource types you offer in Settings to view payments by listing type.
            </p>
            <button
              onClick={() => navigate("/settings")}
              className="mt-5 rounded-md border-0 bg-primary-200 px-6 py-3 font-raleway text-[16px] font-medium text-white"
            >
              Open Settings
            </button>
          </div>
        </div>
      ) : (
      <div className="flex flex-row bg-white h-[75px] w-full max-w-9xl px-4">
      {
          resourceOptions.map((option, i) => {
            return (
              <div 
                key={i} 
                onClick={() => navigate(`/payments/${option.type}`)} 
                className={`${(currentOption?.name === option.name) ? 'text-white bg-primary-200' : 'text-[#4D4D4D] '} ml-6 my-auto text-[16px] font-raleway border-[1px] border-[#E9E9E9] py-2 px-4 rounded-md cursor-pointer`}
              >
                  {option.name}
              </div>
            )
          })
        }
      </div>
      )}
      {resourceOptions.length > 0 ? (
        <>
      <div className="flex flex-row bg-white h-auto w-full my-0.5">
        {
          menuOptions.map((option, i)=> (
          <div 
            key={i} 
            className={`${(currentMenuOption === option.id) ? 'text-primary-200 font-bold' : 'text-[#4D4D4D]'}  ml-6 mt-auto my-auto text-[14px] font-raleway py-2 px-4 rounded-md cursor-pointer`}
            onClick={()=> setCurrentMenuOption(option.id as menuOptionTypes)}
          >
            {capitalizeString(option.name)}
          </div>
          ))
        }
      </div>

      {
        currentMenuOption === "transactions" && (
          <div className="w-full max-w-9xl px-4 font-open-sans my-4">
            <TransactionTypeView resourceType={activeResourceType} />
          </div>
        )
      }

      {
        currentMenuOption === "bank_details" && (
          <div className="w-full max-w-9xl px-4 font-open-sans my-4">
            <BankDetailsView setCurrentMenuOption={setCurrentMenuOption} resourceType={activeResourceType} />
          </div>
        )
      }
      
      

      {
        currentMenuOption === "overview" && (
          <div className="w-full max-w-9xl px-4 font-open-sans my-4">
            <OverviewView  setCurrentMenuOption={setCurrentMenuOption} resourceType={activeResourceType} />
          </div>
        )
      }

      {
        currentMenuOption === "payment_account" && (
          <div className="w-full max-w-9xl px-4 font-open-sans my-4">
            <AccountStatusView setCurrentMenuOption={setCurrentMenuOption} resourceType={activeResourceType} />
          </div>
        )
      }

      {
        currentMenuOption === "payouts" && (
          <div className="w-full max-w-9xl px-4 font-open-sans my-4">
            <PayoutsView setCurrentMenuOption={setCurrentMenuOption} resourceType={activeResourceType} />
          </div>
        )
      }

      {
        currentMenuOption === "reporting" && (
          <div className="w-full max-w-9xl px-4 font-open-sans my-4">
            <ReportingView setCurrentMenuOption={setCurrentMenuOption} resourceType={activeResourceType} />
          </div>
        )
      }

      {
        currentMenuOption === "payments" && (
          <div className="w-full max-w-9xl px-4 font-open-sans my-4">
            <PaymentsView setCurrentMenuOption={setCurrentMenuOption} resourceType={activeResourceType} />
          </div>
        )
      }
        </>
      ) : null}
    </div>
  );
};


type TransactionTypeViewProps = {
  resourceType: ResourceType
  // searchFilterOptions: SearchFilterOptionType
}

export const TransactionTypeView: React.FC<TransactionTypeViewProps> = ({resourceType}) => {

  // let { resourceId } = useMemberState()
  const { transactions } = useLoadCommunityTransactions(resourceType);

  // type menuOptionTypes = "overview" | "bookings"
  // const menuOptions: {id: menuOptionTypes, name: string}[] = [
  //   {id: "overview", name: "Overview"}, 
  //   {id: "bookings", name: `${resourceType} Requests (${resourceBookings && resourceBookings.length > 0 ? resourceBookings.length : 0})`} 
  // ]
  // const [currentOption, setCurrentOption] = useState<menuOptionTypes>(menuOptions[0].id)
  // const [isDownloadingReport, setIsDownloadingReport] = useState<boolean>(false)

  // console.log("currentOption", currentOption)

  // console.log("isAddingResource", isAddingResource)


  return (
    <>
      
        {/* <FilterBox searchType={resourceType} searchFilterOptions={searchFilterOptions} setIsAddingResource={setIsDownloadingReport} /> */}
        <div className="w-11/12 mx-auto font-open-sans my-4">
          <AllTransactions resourceType={resourceType} transactions={transactions} />
        </div>
          
    </>
  )
}


export const AllTransactions: React.FC<{transactions: any[] | undefined, resourceType: ResourceType}> = ({transactions, resourceType}) => {
  const [searchTerm, changeSearchTerm] = useState("")
  const [currentPage, setCurrentPage] = useState(1)
  const [sortField, setSortField] = useState<TransactionSortField>('created')
  const [sortDirection, setSortDirection] = useState<SortDirection>('desc')

  const allTransactions = useMemo(() => transactions ?? [], [transactions])
  const itemsPerPage = 10

  const filteredTransactions = useMemo(
    () => filterTransactions(allTransactions, searchTerm),
    [allTransactions, searchTerm]
  )

  const displayTransactions = useMemo(
    () => sortTransactions(filteredTransactions, sortField, sortDirection),
    [filteredTransactions, sortField, sortDirection]
  )

  const totalPages = Math.ceil(displayTransactions.length / itemsPerPage)
  const startIndex = displayTransactions.length > 0 ? (currentPage - 1) * itemsPerPage : 0
  const endIndex = Math.min(startIndex + itemsPerPage, displayTransactions.length)
  const currentTransactions = displayTransactions.slice(startIndex, endIndex)

  const handlePageChange = (page: number) => {
    setCurrentPage(page)
  }

  const handleSort = useCallback((field: TransactionSortField) => {
    if (field === sortField) {
      setSortDirection((prev) => (prev === 'asc' ? 'desc' : 'asc'))
      return
    }

    setSortField(field)
    setSortDirection(getDefaultTransactionSortDirection(field))
  }, [sortField])

  useEffect(() => {
    setCurrentPage(1)
  }, [searchTerm, sortField, sortDirection])

  useEffect(() => {
    if (totalPages > 0 && currentPage > totalPages) {
      setCurrentPage(totalPages)
    }
  }, [currentPage, totalPages])

  useEffect(() => {
    document.title = `HomeCook | ${capitalizeString(resourceType)} Transactions`;
  }, [resourceType, transactions]);

  const hasSearchFilter = searchTerm.trim().length > 0

  return (
    <>
      <div className="flex flex-col w-full max-w-9xl bg-white mx-auto my-6 rounded-md min-h-[777px] shadow px-6 py-4">
        <div className="flex flex-row w-full justify-between items-center">
          <p className=" font-raleway ml-[24px] mt-[24px] text-[#8A8A8A] text-[14px]" >
            {allTransactions.length > 0 ? (
              displayTransactions.length > 0
                ? `Showing ${startIndex + 1} - ${endIndex} of ${displayTransactions.length} Transactions`
                : "Showing 0 - 0 of 0 Transactions"
            ) : (
              "Showing 0 - 0 of 0 Transactions"
            )}
          </p>

          <div className="flex ml-auto w-full max-w-xs mr-[24px]">
            <NewSearch searchType={`${resourceType} transactions`} searchTerm={searchTerm} changeSearchTerm={changeSearchTerm} />
          </div>
        </div>


        <div className="w-full overflow-x-auto">
          {
            allTransactions.length > 0 ? (
              <TransactionsList
                resourceType={resourceType}
                transactions={displayTransactions}
                currentPage={currentPage}
                currentTransactions={currentTransactions}
                totalPages={totalPages}
                itemsPerPage={itemsPerPage}
                handlePageChange={handlePageChange}
                sortField={sortField}
                sortDirection={sortDirection}
                onSort={handleSort}
                hasSearchFilter={hasSearchFilter}
              />
            ) : (
              <div className="flex flex-row font-open-sans justify-evenly font-light text-center text-[#013847]/40 ">
                No {resourceType} transaction to show
              </div>
            )
          }
        </div>
        
      </div>
    </>
  )
}


type OverviewViewProps = {
  resourceType: ResourceType
  setCurrentMenuOption: React.Dispatch<React.SetStateAction<menuOptionTypes>>
}


const PayoutsView: React.FC<OverviewViewProps> = ({resourceType, setCurrentMenuOption}) => {
  var { communityId, authUser } = useAuthState()
  return (
    <div className="w-11/12 mx-auto font-open-sans my-2">
      <Payouts communityId={communityId} userId={authUser?.username || ''} />
    </div>
  )
}

const ReportingView: React.FC<OverviewViewProps> = ({resourceType, setCurrentMenuOption}) => {

  var { communityId, authUser } = useAuthState()
  return (
    <div className="w-11/12 mx-auto font-open-sans my-2">
      <ReportingChart communityId={communityId} userId={authUser?.username || ''} />
    </div>
  )
}

export const PaymentsView: React.FC<OverviewViewProps> = ({resourceType, setCurrentMenuOption}) => {
  var { communityId, authUser } = useAuthState()
  return (
    <div className="w-full max-w-9xl mx-auto font-open-sans px-6">
      <PaymentProcessing 
        communityId={communityId} 
        userId={authUser?.username || ''} 
        hideHeader={true}
      />
    </div>
  )
}

const BankDetailsView: React.FC<OverviewViewProps> = ({resourceType, setCurrentMenuOption}) => {
  var { communityId, authUser } = useAuthState()
  return (
    <div className="w-11/12 mx-auto font-open-sans">
      <PaymentAccountDetails communityId={communityId} userId={authUser?.username || ''} />
    </div>
  )
}

const AccountStatusView: React.FC<OverviewViewProps> = ({resourceType, setCurrentMenuOption}) => {
  var { communityId, authUser } = useAuthState()
  return (
    <div className="w-11/12 mx-auto font-open-sans my-2">
      <AccountOnboarding communityId={communityId} userId={authUser?.username || ''} />
    </div>
  )
}

const OverviewView: React.FC<OverviewViewProps> = ({resourceType, setCurrentMenuOption}) => {
  var { communityId, authUser } = useAuthState()
  return (
    <div className="w-11/12 mx-auto font-open-sans my-2">
      <DashboardAccess setCurrentMenuOption={setCurrentMenuOption} communityId={communityId} userId={authUser?.username || ''} />
      <div className="mt-2"/>
      <FinancialAccount communityId={communityId} userId={authUser?.username || ''} />
      <div className="mt-2"/>
      <PaymentStatus communityId={communityId} userId={authUser?.username || ''} />
    </div>
  )
}


export default TransactionsPage;


// export default TransactionsPage;
